import { Button, ButtonGroup, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { Modal } from "components";
import { API } from "config";
import { useConsultant } from "hooks";
import { useState } from "react";
import { useParams } from "react-router";
import { Authenticate } from "screens";

export default function Expire({ ...props }){

    const queryClient = useQueryClient()
    const toast = useToast()
    const params = useParams()
    const consultant = useConsultant(params?.id)
    const [ loading, setLoading ] = useState(false)
    const auth = useDisclosure()

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/consultants/${consultant.data?.id}/expire`)
            consultant.refetch()
            toast({ title: 'O cadastro foi expirado!' })
            queryClient.invalidateQueries('consultants')
            props?.onClose()
        }catch(err){
            toast({ title: 'Não foi possível expirar o cadastro.', description: err?.response?.data?.message, status: 'warning'})
            setLoading(false)
        }
    }

    return(
    <>
    <Modal title={`Expirar cadastro de ${consultant.data?.customer?.name}?`} {...props}>
        <ModalBody>
            <Stack spacing={4}>
                <Text fontSize="sm">Você está prestes a forçar a expiração do cadastro de um consultor. </Text>
                <Text fontSize="sm">Esta ação removerá todo o histórico do consultor, bonificação e pontuação gerada, assim como não será possível mais retornar à rede atual.</Text>
                <Text fontSize="sm" fontWeight="bold">⚠️ Tem certeza que deseja continuar? Esta ação é irreversível!</Text>
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button colorScheme="red" isLoading={loading} loadingText="Expirando cadastro..." onClick={auth.onOpen}>⚠️ Expirar cadastro de consultor</Button>
                <Button onClick={props?.onClose}>Fechar</Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}